import React, { useEffect, useState } from "react";
import { Translator } from "./translator";

const CONSENT_KEY = "teche_ads_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const { translateText, lang } = Translator();

  // --- Static copy for it / en / fr -------------------------
  const baseTextByLang = {
    it: {
      title: "Impostazioni cookie",
      body:
        "Questo sito utilizza cookie tecnici e di terze parti. Se non acconsenti all'utilizzo dei cookie di terze parti, alcune funzionalità potrebbero non essere disponibili. Per maggiori informazioni consulta la cookie policy.",
      accept: "Accetto tutto",
      deny: "Non accetto",
    },
    en: {
      title: "Cookie settings",
      body:
        "This site uses technical and third-party cookies. If you do not consent to the use of third-party cookies, some features may not be available. For more information, please see the cookie policy.",
      accept: "Accept all",
      deny: "Reject",
    },
    fr: {
      title: "Paramètres des cookies",
      body:
        "Ce site utilise des cookies techniques et des cookies tiers. Si vous n’acceptez pas les cookies tiers, certaines fonctionnalités peuvent ne pas être disponibles. Pour plus d’informations, veuillez consulter la politique relative aux cookies.",
      accept: "Tout accepter",
      deny: "Refuser",
    },
  };

  const activeBaseText = baseTextByLang[lang] || baseTextByLang.it;
  const [translatedText, setTranslatedText] = useState(activeBaseText);

  // Static for it/en/fr, Translator fallback for others
  useEffect(() => {
    let cancelled = false;

    // Direct use of static copy for these three
    if (lang === "it" || lang === "en" || lang === "fr") {
      setTranslatedText(baseTextByLang[lang] || baseTextByLang.it);
      return;
    }

    // Other languages → translate from Italian base
    const translateAll = async () => {
      try {
        const source = baseTextByLang.it;
        const entries = Object.entries(source);

        const translatedEntries = await Promise.all(
          entries.map(async ([key, value]) => {
            if (!value) return [key, value];
            const out = await translateText(value);
            return [key, out || value]; // fallback to Italian if empty
          })
        );

        if (!cancelled) {
          setTranslatedText(Object.fromEntries(translatedEntries));
        }
      } catch (err) {
        if (!cancelled) {
          setTranslatedText(baseTextByLang.it);
        }
      }
    };

    translateAll();

    return () => {
      cancelled = true;
    };
  }, [lang, translateText]);

  // Consent logic
  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (saved === "granted") {
      window.acceptAllCookies?.();
      setShow(false);
    } else if (saved === "denied") {
      window.rejectAllCookies?.();
      setShow(false);
    } else {
      setShow(true);
    }
  }, []);

  const accept = () => {
    window.acceptAllCookies?.();
    localStorage.setItem(CONSENT_KEY, "granted");
    window.dispatchEvent(new Event("ads-consent-granted"));
    setShow(false);
  };

  const deny = () => {
    window.rejectAllCookies?.();
    localStorage.setItem(CONSENT_KEY, "denied");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] bg-white/95 border rounded-xl shadow-xl p-4 sm:p-5">
      <div className="sm:flex sm:items-center sm:justify-between gap-3">
        <div>
          <h3 className="font-semibold text-black">{translatedText.title}</h3>
          <p className="text-sm text-gray-700 mt-1">{translatedText.body}</p>
        </div>
        <div className="mt-3 sm:mt-0 flex gap-2 justify-end">
          <button
            onClick={deny}
            className="px-4 py-2 rounded-lg border text-black"
          >
            {translatedText.deny}
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 rounded-lg bg-[#324B8E] text-white"
          >
            {translatedText.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
